import React from "react";
import { StarRating, scoreBand } from "@/components/site/Stars";
import ScoreLegend from "@/components/site/ScoreLegend";

/** Composite score badge — auto-avg of all rating categories (skip nps/overall). Renders soft
 * warm chip using scoreBand() from Stars.jsx. The pill acts as a ScoreLegend trigger so parents
 * can tap it to learn what each band means (see /components/site/ScoreLegend.jsx). */
export default function ReviewCompositeScore({ ratings, testid }) {
  if (!ratings || typeof ratings !== "object") return null;
  const nums = Object.entries(ratings)
    .filter(([k, v]) => k !== "nps" && k !== "overall" && typeof v === "number")
    .map(([, v]) => v);
  if (nums.length === 0) return null;
  const avg = nums.reduce((a, b) => a + b, 0) / nums.length;
  const band = scoreBand(avg);
  return (
    <div className="flex flex-col items-end gap-1" data-testid={testid}>
      <StarRating value={avg} />
      <div data-testid={`${testid}-band`}>
        <ScoreLegend triggerTestid={`${testid}-legend-trigger`}>
          <button
            type="button"
            className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold tabular-nums cursor-help hover:brightness-95 transition"
            style={{ backgroundColor: band.bg, color: band.text }}
            title="Klik untuk melihat arti skor"
          >
            {avg.toFixed(1)} · {band.label}
          </button>
        </ScoreLegend>
      </div>
    </div>
  );
}
